module.exports = __webpack_public_path__ + "fonts/7860908.ttf";